/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { term, isEditionAuthorized, isDeletionAuthorized, openEditStudentPage, openRegistrationCancellationModal }
) => (
  <>
    {
      isEditionAuthorized &&
      <>
        <OverlayTrigger
          overlay={<Tooltip id="student-registration-renew-tooltip">Kayıt Yenile</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm"
            onClick={() => openEditStudentPage("kayit-yenile", term, row.id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Code/Loading.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
        <OverlayTrigger
          overlay={<Tooltip id="student-edit-tooltip">Düzenle</Tooltip>}
        >
          <a
            className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
            onClick={() => openEditStudentPage("duzenle", term, row.id)}
          >
            <span className="svg-icon svg-icon-md svg-icon-primary">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
              />
            </span>
          </a>
        </OverlayTrigger>
      </>
    }
    {
      isDeletionAuthorized &&
      <OverlayTrigger
        overlay={<Tooltip id="student-cancel-registration-tooltip">Kaydı İptal Et</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
          onClick={() => openRegistrationCancellationModal(term, row.id)}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    }    
  </>
);